/* eslint-disable */

import React from "react";
import PropTypes from "prop-types";
import { Link, useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useQuery } from "react-apollo";
import { Control, Icon, Select, Label, Help } from "rbx";
import { ALL_PAYMENT_TERMS_QUERY } from "../../graphql/PaymentTerms/PaymentTerms.graphql";
import { useCurrentUserRoles } from "../Authorization";
import { saveFilterState, clearFilterState } from "../../utils";

const PaymentTermSelect = ({
  label,
  size,
  name,
  onChange,
  disabled = false,
  value,
  where,
  help,
  required = false,
  icon,
  showLabel = false
}) => {
  const history = useHistory();
  const roles = useCurrentUserRoles();

  const { data, loading, error } = useQuery(ALL_PAYMENT_TERMS_QUERY, {
    variables: {
      where,
      orderBy: "TermDescription_ASC",
      orderByMulti: ["TermDescription_ASC"]
    },
    fetchPolicy: "network-only"
  });

  const isAdmin = roles.some(role => role === "ADMIN");
  const isBill = roles.some(role => role === "FIN");

  const handleLinkClick = () => {
    if (isAdmin || isBill) {
      history.push("/finance/payment-terms");
    }
  };
 
  return (
    !loading &&
    data?.PaymentTerms && (
      <Control size={size} iconLeft={!!icon}>
        {showLabel && (isAdmin || isBill) ? (
          <Label as={Link} tabIndex="-1" textColor="link" onClick={handleLinkClick}>
            {label}
          </Label>
        ) : (
          <Label>{label}</Label>
        )}
        <Select.Container
          state={loading ? "loading" : null}
          fullwidth
          color={
            error ||
            help ||
            (required && (value === "" || value === "0" || value === 0))
              ? "danger"
              : "secondary"
          }
          size={size}
        >
          <Select
            multiple={false}
            name={name}
            value={value}
            onChange={onChange}
            required={required}
            disabled={disabled}
            pattern="0"
          >
            <Select.Option value={0}>Select...</Select.Option>
            {!loading &&
              data?.PaymentTerms.map(
                ({ RecId, TermCode, TermDescription }, i) => (
                  <Select.Option value={RecId} key={`system-code-select-${i}`}>
                    {TermDescription}
                  </Select.Option>
                )
              )}
          </Select>
        </Select.Container>
        {icon && (
          <Icon size={size} align="left">
            <FontAwesomeIcon icon={icon} />
          </Icon>
        )}
        {help && <Help color="danger">{help}</Help>}
      </Control>
    )
  );
};

PaymentTermSelect.propTypes = {
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  name: PropTypes.string,
  label: PropTypes.string,
  size: PropTypes.string,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  where: PropTypes.object,
  help: PropTypes.string,
  required: PropTypes.bool,
  icon: PropTypes.string,
  showLabel: PropTypes.bool
};
PaymentTermSelect.defaultOptions = {
  value: 0
};
export default PaymentTermSelect;
